<template>
    <div style="min-height: 700px">
        <div class="card my-3">
            <div class="card-header">
                <div class="row">
                    <div class="col-9">
                        {{ projectClassInfo.className }}
                    </div>
                    <div class="col-3 text-right">
                        {{ projectClassInfo.stateName }}
                    </div>
                </div>
            </div>
            <table class="table table-bordered mb-0">
                <tbody>
                <tr>
                  <th class="text-center align-middle" style="width: 10%">所属项目</th>
                  <td class="text-left align-middle" colspan="7">
                    <div class="row">
                      <div class="col" style="line-height: 27px">{{ projectClassInfo.projectName }}</div>
                      <div class="col-auto text-right">
                        <button class="btn btn-info btn-sm mr-2" @click="btnShowProjectInfo_Click">项目基本信息
                        </button>
                        <button class="btn btn-info btn-sm mr-2" @click="btnShowProjectTeacherCourse_Click">
                          课程安排信息
                        </button>
                        <button class="btn btn-info btn-sm mr-2" @click="btnShowProjectAssessment_Click">项目考核信息
                        </button>
                        <button class="btn btn-info btn-sm" @click="btnShowProjectAchievement_Click">项目成果物信息
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th class="text-center align-middle" style="width: 10%">项目批次</th>
                  <td class="text-left align-middle" colspan="7">
                    <div class="row">
                      <div class="col" style="line-height: 27px">{{ projectClassInfo.batchName }}</div>
                      <div class="col-auto text-right">
                        <button class="btn btn-info btn-sm" @click="btnShowProjectBatchInfoDialog_Click">
                          批次基本信息
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th class="text-center align-middle" style="width: 10%">开始日期</th>
                  <td class="text-left align-middle" style="width: 15%">{{ projectClassInfo.startDateString }}</td>
                  <th class="text-center align-middle" style="width: 10%">结束日期</th>
                  <td class="text-left align-middle" style="width: 15%">{{ projectClassInfo.endDateString }}</td>
                  <th class="text-center align-middle" style="width: 10%">计划人数</th>
                  <td class="text-left align-middle" style="width: 15%">{{ projectClassInfo.studentCount }}</td>
                  <th class="text-center align-middle" style="width: 10%">联系人</th>
                  <td class="text-left align-middle" style="width: 15%">
                    <a href="#"
                       @click.prevent="btnShowClassContactInfoDialog_Click">{{ projectClassInfo.personName }}</a>
                  </td>
                </tr>
                <tr>
                  <th class="text-center align-middle" style="width: 10%">班级详情</th>
                  <td class="text-left align-middle" colspan="7">
                    <button class="btn btn-info btn-sm mr-2" @click="btnShowClassScheduleDialog_Click">教学日程安排
                    </button>

                    <button class="btn btn-info btn-sm" @click="btnShowStartClassNotificationDialog_Click">开班通知
                    </button>
                  </td>
                </tr>
                </tbody>
            </table>
            <div class="card card-body" v-if="projectClassInfo.state >= projectClassState.V2_SIGNIN">
                <template v-if="projectClassInfo.state === projectClassState.V2_SIGNIN">
                    <!-- 学员报名信息查看及确认 -->
                </template>
            </div>
            <div class="card-body" style="min-height: 500px">
              <template v-if="projectClassInfo.state >= projectClassState.V2_SIGNIN">
                <student-class-data-manage :class-id="projectClassInfo.classId"
                                           :user-id="projectClassInfo.organId" 
                                           :user-type="userTypeData.ORGAN"
                                           :batch-id="projectClassInfo.batchId"
                                           :class-state="projectClassInfo.state">
                </student-class-data-manage>
              </template>
              <template v-if="projectClassInfo.state >= projectClassState.V4_EXECUTE">
                <study-survey-data-manage class="mt-3" :class-id="classId"
                                          :project-id="projectClassInfo.projectId"
                                          :can-edit="projectClassInfo.state===projectClassState.V4_EXECUTE">
                </study-survey-data-manage>
                <class-training-resource-edit class="mt-3" :class-id="classId"
                                              :can-edit="projectClassInfo.state===projectClassState.V4_EXECUTE">
                </class-training-resource-edit>
              </template>
            </div>
            <div class="card-footer text-center">
                <template v-if="projectClassInfo.state === projectClassState.V1_PREPARE">
                    <button class="btn btn-danger" @click="btnUpdateProjectClassState_Click(projectClassState.V2_SIGNIN, '是否开始学员报名？')">开始报名</button>
                </template>
                <template v-if="projectClassInfo.state === projectClassState.V2_SIGNIN">
                    <button class="btn btn-danger" @click="btnUpdateProjectClassState_Click(projectClassState.V3_CONFIRM, '是否结束学员报名？结束后，学员将不能再报名本班级培训')">报名结束</button>
                </template>
                <template v-if="projectClassInfo.state === projectClassState.V3_CONFIRM">
                    <button class="btn btn-danger" @click="btnUpdateProjectClassState_Click(projectClassState.V4_EXECUTE, '确定开始班级教学实施？')">确认开班</button>
                </template>
                <template class="card-footer text-center" v-if="projectClassInfo.state === projectClassState.V4_EXECUTE">
                  <router-link class="btn btn-primary mr-2" :to="{name: 'OrganCertificateManage', params: {classId: classId}}">证书管理</router-link>
                  <button class="btn btn-danger"
                          @click="btnUpdateProjectClassState_Click(projectClassState.V5_COMPLETED, '确定班级教学实施已结束？')">
                    班级教学实施结束
                  </button>
                </template>
            </div>
        </div>
        <b-modal v-model="isShowProjectInfoViewDialogOpen"
                 title="项目实施详细信息" size="xl"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
          <project-info-view :project-id="projectClassInfo.projectId"></project-info-view>
        </b-modal>
        <b-modal v-model="isShowProjectTeacherCourseViewDialogOpen"
                 title="课程安排详细信息" size="lg"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
          <project-teacher-course-view :project-id="projectClassInfo.projectId"></project-teacher-course-view>
        </b-modal>
        <b-modal v-model="isShowProjectAssessmentViewDialogOpen"
                 title="项目考核详细信息" size="lg"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
          <project-assessment-view :project-id="projectClassInfo.projectId"></project-assessment-view>
        </b-modal>
        <b-modal v-model="isShowProjectAchievementViewDialogOpen"
                 title="项目成果物详细信息" size="lg"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
          <project-achievement-view :project-id="projectClassInfo.projectId"></project-achievement-view>
        </b-modal>
        <b-modal v-model="isShowProjectBatchInfoDialogOpen"
                 title="项目批次详细信息"
                 ok-title="确定" :ok-only="true" size="xl"
                 :no-close-on-backdrop="true">
          <project-batch-info-view :batch-id="projectClassInfo.batchId"></project-batch-info-view>
        </b-modal>
        <b-modal v-model="isShowClassScheduleInfoDialogOpen"
                 title="班级教学日程安排信息" size="xl"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
          <project-class-schedule-edit v-if="$store.state.userType===userTypeData.ORGAN" :class-id="classId" :project-id="projectClassInfo.projectId"></project-class-schedule-edit>
          <project-class-schedule-view v-else :class-id="classId"></project-class-schedule-view>
        </b-modal>

        <b-modal v-model="isShowStartClassNotificationDialogOpen"
                 title="开班通知管理" size="xl"
                 :hide-footer="true"
                 :no-close-on-backdrop="true">
          <start-class-notification-edit :class-id="classId" :can-edit="$store.state.userType===userTypeData.ORGAN"></start-class-notification-edit>
        </b-modal>
        <b-modal v-model="isShowClassContactViewDialogOpen"
                 title="联系人详细信息" size="lg"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
          <person-basic-info-view :person-id="projectClassInfo.personId" :show-detail-info="false"></person-basic-info-view>
          <person-contact-info-view :person-id="projectClassInfo.personId" class="mt-3"></person-contact-info-view>
        </b-modal>
    </div>
</template>

<script>
import projectApi from "@/utils/api/project";
import dictionary from "@/utils/dictionary";

import ProjectAssessmentView from "@/components/project/project/ProjectAssessmentView";
import ProjectTeacherCourseView from "@/components/project/project/ProjectTeacherCourseView";
import ProjectInfoView from "@/components/project/project/ProjectInfoView";
import ProjectBatchInfoView from "@/components/project/batch/ProjectBatchInfoView";
import PersonBasicInfoView from "@/views/organ/OrganPersonBasicInfoView";
import PersonContactInfoView from "@/views/organ/OrganPersonContactInfoView";
import ProjectClassScheduleView from "@/components/project/project/ProjectClassScheduleView";
import StudentClassDataManage from "@/components/study/StudentClassDataManage";
import StudySurveyDataManage from "@/components/study/StudySurveyDataManage";
import ClassTrainingResourceEdit from "@/components/study/ClassTrainingResourceEdit";
import ProjectAchievementView from "@/components/project/project/ProjectAchievementView";
import StartClassNotificationEdit from "@/components/study/StartClassNotificationEdit";
import ProjectClassScheduleEdit from "@/components/project/project/ProjectClassScheduleEdit";

export default {
    name: "OrganProjectClassManage",
    data: function () {
        return {
            classId: this.$route.params.classId,

            projectClassState: dictionary.projectClassState,

            projectClassInfo: {},

            isShowProjectInfoViewDialogOpen: false,
            isShowProjectTeacherCourseViewDialogOpen: false,
            isShowProjectAssessmentViewDialogOpen: false,
            isShowProjectAchievementViewDialogOpen: false,
            isShowProjectBatchInfoDialogOpen: false,
            isShowClassScheduleInfoDialogOpen: false,
            isShowStartClassNotificationDialogOpen: false,
            isShowClassContactViewDialogOpen: false,
            userTypeData: dictionary.userType,
        };
    },
    components: {
      ProjectClassScheduleEdit,
      StartClassNotificationEdit,
      ProjectAchievementView,
      ClassTrainingResourceEdit,
      StudySurveyDataManage,
      StudentClassDataManage,
      ProjectInfoView,
      ProjectTeacherCourseView,
      ProjectAssessmentView,
      PersonContactInfoView,
      PersonBasicInfoView,
      ProjectBatchInfoView,
      ProjectClassScheduleView,
    },
    mounted() {
        this.getProjectClassInfo();
    },
    methods: {
        getProjectClassInfo() {
            projectApi.class.getProjectClassInfo(this.classId).then(res => {
                this.projectClassInfo = res.data;
                console.log(this.projectClassInfo)
            });
        },

        btnUpdateProjectClassState_Click(state, message) {
            if (confirm(message)) {
                let info = {
                    classId: this.classId,
                    state: state
                };

                projectApi.class.updateProjectClassState(info).then(res => {
                    this.getProjectClassInfo();
                });
            }
        },

        btnShowProjectInfo_Click() {
          this.isShowProjectInfoViewDialogOpen = true;
        },

        btnShowProjectTeacherCourse_Click() {
          this.isShowProjectTeacherCourseViewDialogOpen = true;
        },

        btnShowProjectAssessment_Click() {
          this.isShowProjectAssessmentViewDialogOpen = true;
        },

        btnShowProjectAchievement_Click() {
          this.isShowProjectAchievementViewDialogOpen = true;
        },

        btnShowProjectBatchInfoDialog_Click() {
          this.isShowProjectBatchInfoDialogOpen = true;
        },

        btnShowClassScheduleDialog_Click() {
          this.isShowClassScheduleInfoDialogOpen = true;
        },

        btnShowStartClassNotificationDialog_Click() {
          this.isShowStartClassNotificationDialogOpen = true;
        },

        btnShowClassContactInfoDialog_Click() {
          this.isShowClassContactViewDialogOpen = true;
        },
    }
}
</script>

<style scoped>

</style>
